import { INPUT_TYPES } from '../utils/constants';
export default {
  title: 'Slider Thumbnails',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.oneRow;
  },
  type: INPUT_TYPES.BOOLEAN,
  "default": false,
  description: "Choose if you want to have slider thumbnails in the gallery. Note that this option is relevant only\n  to galleries that render the slideShowView component.\n  "
};